import { useQuery } from '@tanstack/react-query';
import { SIMULATION_ENDPOINT_PREFIX } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import { RQAPICallWithData } from 'store/APIClient';

export type HrNature = {
    id: number;
    code: string;
    label: string;
    isLeaf: boolean;
};

export const useGetAllHrNatures = () =>
    useQuery({
        queryKey: ['hr_natures'],

        queryFn: async () => {
            const response = await RQAPICallWithData<HrNature[]>({
                endpoint: `${SIMULATION_ENDPOINT_PREFIX}/hr_natures`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
